import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import UserAvatar from 'react-user-avatar';
import FollowerRequestControl from "./FollowerRequestControl";
import * as apiConfig from "../../../api/config";
import { approveFollowerRequest, rejectFollowerRequest } from "../../../redux/actions/riderNetworkActions";
import { toast } from "react-toastify";
import "./ProfilePage.css";


function ProfileNetworkControl({
    user,
    subjectUser,
    networkConnection,
    onFollowUser,
    onUnfollowUser,
    onRemoveFollower,
    onBlockUser,
    onUnblockUser
}) {

    useEffect(() => {
    }, [])

    function getConnectionStatus() {
        if (networkConnection.you.connected && networkConnection.them.connected) return "You follow each other"; 
        if (!networkConnection.you.connected && networkConnection.them.connected) return `${subjectUser.firstName} follows you`;
        if (networkConnection.you.connected && !networkConnection.them.connected && !networkConnection.them.blocked) return `You follow ${subjectUser.firstName}`;
        if (networkConnection.them.blocked) return `You have blocked ${subjectUser.firstName}`;
    }

    return (
        <div className="profile-network-status">
            <div className="profile-avatar-container">
                <React.Fragment>
                    <UserAvatar className="profile-banner-avatar d-block d-sm-none" size="100" name={`${subjectUser.firstName} ${subjectUser.surname}`} src={subjectUser.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${subjectUser.id}.png` : ""} />
                    <UserAvatar className="profile-banner-avatar d-none d-sm-block" size="150" name={`${subjectUser.firstName} ${subjectUser.surname}`} src={subjectUser.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${subjectUser.id}.png` : ""} />
                </React.Fragment>
            </div>
            <div className="profile-banner-info">
                <div className="profile-banner-header">
                    <div className="profile-banner-details">
                        <h2 className="name">{`${subjectUser.firstName} ${subjectUser.surname}`}</h2>
                        <div className="location">{subjectUser.location}</div>
                    </div>
                    {!networkConnection.you.connected && !networkConnection.you.pending && !networkConnection.you.blocked && !networkConnection.them.blocked &&
                        <button className="btn btn-info btn-sm btn-follow" onClick={onFollowUser}>{subjectUser.approveFollowers ? "Request to Follow" : "Follow"}</button>
                    }
                    {networkConnection.you.pending && 
                        <button className="btn btn-info btn-sm btn-follow" onClick={onUnfollowUser}>Cancel Follow Request</button>
                    }
                </div>
                {!networkConnection.you.blocked &&
                    <div className="network">
                        {networkConnection.them.pending ?
                            <div className="follow-request-dialog">
                                <div className="follow-request-message muted">{`${subjectUser.firstName} would like to follow you.`}</div>
                                <FollowerRequestControl subjectUser={subjectUser} />
                            </div>
                        :
                            <React.Fragment>
                                <div className="network-infographic" title={getConnectionStatus()}>
                                    <div className="network-connection">
                                        {networkConnection.you.connected && networkConnection.them.connected && <span className="fas fa-exchange-alt"></span>}
                                        {!networkConnection.you.connected && networkConnection.them.connected && <span className="fas fa-long-arrow-alt-right"></span>}
                                        {networkConnection.you.connected && !networkConnection.them.connected && !networkConnection.them.blocked && <span className="fas fa-long-arrow-alt-left"></span>}
                                        {networkConnection.them.blocked && <span className="fas fa-times"></span>}
                                    </div>

                                    {(networkConnection.you.connected || networkConnection.them.connected || networkConnection.them.blocked) &&
                                        <div className="your-avatar-container">
                                            <UserAvatar className="your-avatar" size="50" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                        </div>
                                    }

                                    {(networkConnection.you.connected || networkConnection.them.connected || networkConnection.them.blocked) &&
                                        <div className="dropdown dropleft network-options">
                                            <button className="btn btn-link network-connection-options" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <span className="fas fa-ellipsis-h more-options"></span>
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dLabel">

                                                <h6 className="dropdown-header">{getConnectionStatus()}</h6>
                                                
                                                {networkConnection.you.connected && !networkConnection.them.blocked && <a className="dropdown-item" onClick={onUnfollowUser} href="#">Unfollow</a>}
                                                {networkConnection.them.connected && 
                                                    <React.Fragment>
                                                        <div className="dropdown-divider"></div>
                                                        <a className="dropdown-item" onClick={onRemoveFollower} href="#">Remove Follower</a>
                                                        <a className="dropdown-item" onClick={onBlockUser} href="#">Block Follower</a>
                                                    </React.Fragment>
                                                }
                                                {networkConnection.them.blocked &&
                                                    <React.Fragment>
                                                        <div className="dropdown-divider"></div>
                                                        <a className="dropdown-item" onClick={onUnblockUser} href="#">Unblock Follower</a>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="network-status" style={{display: "none"}}>
                                    {networkConnection.you.connected && networkConnection.them.connected && <span className="muted">You follow each other</span>}
                                    {!networkConnection.you.connected && networkConnection.them.connected && <span className="muted">{`${subjectUser.firstName} follows you`}</span>}
                                    {networkConnection.you.connected && !networkConnection.them.connected && <span className="muted">{`You follow ${subjectUser.firstName}`}</span>}
                                </div>

                            </React.Fragment>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

ProfileNetworkControl.propTypes = {
    user: PropTypes.object.isRequired,
    subjectUser: PropTypes.object.isRequired,
    networkConnection: PropTypes.object.isRequired,
    onFollowUser: PropTypes.func.isRequired,
    onUnfollowUser: PropTypes.func.isRequired,
    onRemoveFollower: PropTypes.func.isRequired,
    onBlockUser: PropTypes.func.isRequired,
    onUnblockUser: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileNetworkControl);





// WEBPACK FOOTER //
// ./src/components/user/profile/ProfileNetworkControl.js